import { render, staticRenderFns } from "./Parcels.vue?vue&type=template&id=08e41d82&"
import script from "./Parcels.vue?vue&type=script&lang=js&"
export * from "./Parcels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports